import React from 'react';
import { useTranslation } from 'react-i18next';
import { Send } from 'lucide-react';

interface SubmitButtonProps {
  isSubmitting: boolean;
  isCheckingPassword: boolean;
  isDisabled: boolean;
}

export default function SubmitButton({
  isSubmitting,
  isCheckingPassword,
  isDisabled,
}: SubmitButtonProps) {
  const { t } = useTranslation('createNote');

  return (
    <button
      type="submit"
      disabled={isDisabled || isSubmitting || isCheckingPassword}
      className={`
        w-full bg-blue-500 text-white py-4 rounded-xl
        hover:bg-blue-600 flex items-center justify-center
        transition-all duration-200 text-lg font-medium
        ${(isDisabled || isSubmitting || isCheckingPassword) ? 'opacity-50 cursor-not-allowed' : ''}
      `}
    >
      <Send className="w-5 h-5 mr-2" />
      {isSubmitting ? t('form.submit.creating') : 
       isCheckingPassword ? t('form.submit.checking') : 
       t('form.submit.create')}
    </button>
  );
}